<template lang="pug">
  .text-error(v-if="modelErrors")
    small {{ modelErrors[0] }}
  .text-error(v-else-if="validation && validation.$dirty && keys.length > 0")
    small {{ translate(keys[0]) }}
</template>

<script>
export default {
  props: { validation: Object, modelErrors: Array },

  data() {
    return {
      mapping: {
        between: {
          i18n: 'modelValidationConstraints.between',
          options: ({ between }) => between,
        },
        url: { i18n: 'modelValidationConstraints.url' },
        required: {
          i18n: 'modelValidationConstraints.required',
          options: ({ required }) => required,
        },
        integer: { i18n: 'not_an_integer' },
        minLength: {
          i18n: 'too_short',
          options: params => ({ count: params.minLength.min }),
        },
        maxLength: {
          i18n: 'too_long',
          options: params => ({ count: params.maxLength.max }),
        },
        cpf: { i18n: 'cpf' },
        cnpj: { i18n: 'cnpj' },
        sameAs: { i18n: 'same_as' },
        minValue: {
          i18n: 'greater_than',
          options: params => ({ count: params.minValue.min }),
        },
        maxValue: {
          i18n: 'less_than',
          options: params => ({ count: params.maxValue.max }),
        },
        email: { i18n: 'email_format' },
        phone: { i18n: 'modelValidationConstraints.phone' },
      },
    }
  },

  computed: {
    keys() {
      return Object.keys(this.mapping).filter(
        key => this.validation[key] === false,
      )
    },
  },

  methods: {
    translate(key) {
      const item = this.mapping[key]
      return this.$i18n.t(
        `errors.${item.i18n}`,
        item.options ? item.options(this.validation.$params) : undefined,
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.text-error
  margin-top -.3rem
</style>
